<script setup lang="ts">
import AppIcon from '@/shared/ui/AppIcon/index';
import JournalCard from '@/entities/journal/ui/JournalCard.vue';
import { usePublications } from '@/pages/main/composables/usePublications';

const isMobile: boolean = useIsMobile();
const { articles, link } = usePublications();
</script>

<template>
  <section
    v-if="articles.length"
    :class="['publications-section', { _mobile: isMobile }]"
    data-testid="publications-section"
  >
    <h2 class="publications-section__title">
      <NuxtLink
        class="publications-section__link"
        :to="link"
        data-testid="publications-section-link"
      >
        Публикации юристов
        <AppIcon
          name="ArrowRightMain"
          :width="isMobile ? '8px' : '16px'"
          :height="isMobile ? '16px' : '28px'"
          class="publications-section__icon"
        />
      </NuxtLink>
    </h2>

    <div class="publications-section__list">
      <JournalCard v-for="article in articles" :key="article.id" :card="article" />
    </div>
  </section>
</template>

<style lang="less">
.publications-section {
  .container-d();
  .flex-column(@size-x5);

  padding-bottom: 150px;

  &__title {
    .h-offset-reset();
    .title-section();
  }

  &__link {
    .color-change-hover();

    display: inline-flex;
    align-items: baseline;
    gap: @size-x3;
    color: @color-elephant;
  }

  &__list {
    display: grid;
    gap: @size-x5;
    row-gap: @size-x10;
    grid-template-columns: repeat(auto-fill, minmax(23%, 1fr));
  }

  &._mobile {
    .container-m();

    padding-bottom: @size-x10;
  }

  &._mobile &__title {
    font-size: @size-x6;
    font-weight: 700;
    line-height: @size-x8;
  }

  &._mobile &__list {
    display: flex;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    margin-right: -@size-x4;
    margin-left: -@size-x4;
    padding-right: @size-x4;
    padding-left: @size-x4;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
